import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private translateService:TranslateService) { }

  /**
   * get the translate value
   * @param key
   * @returns {any}
   */
  translate(key) {
    let translated;
    this.translateService.get(key).subscribe((res) => {
      translated = res;
    });
    return translated;
  }

}
